<template>
  <layout-panel :collapse="true">
    <template slot="header">搜索</template>
    <el-form :model="search"
             ref="searchForm"
             label-width="96px"
             label-position="right"
             size="medium"
             @submit.native.prevent="onSearch()">
      <div class="re-el-form__flex">
        <el-form-item label="任务上线时间"
                      prop="onlineRange">
          <el-date-picker
            v-model="search.onlineRange"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="center"
            class="width-max"
            clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="任务下线时间"
                      prop="offlineRange">
          <el-date-picker
            v-model="search.offlineRange"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="center"
            class="width-max"
            clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="任务更新时间"
                      prop="lastupdatetimeRange">
          <el-date-picker
            v-model="search.lastupdatetimeRange"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="center"
            class="width-max"
            clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="项目"
                      prop="projectid">
          <remote-select class="width-max"
                         clearable
                         multiple
                         id-key="number"
                         label-key="name"
                         value-key="id"
                         @change="projectIdChanged()"
                         placeholder="请输入项目 名称/编号 进行搜索"
                         v-model="search.projectid"
                         :query-request="getProjectTable"
                         :find-request="getProjectDetail">
          </remote-select>
        </el-form-item>
        <el-form-item label="排除项目"
                      prop="not_projectid"
                      v-if="showExcludeProject">
          <remote-select class="width-max"
                         clearable
                         multiple
                         id-key="number"
                         label-key="name"
                         value-key="id"
                         placeholder="请输入项目 名称/编号 进行搜索"
                         v-model="search.not_projectid"
                         :query-request="getProjectTable"
                         :find-request="getProjectDetail">
          </remote-select>
        </el-form-item>
        <el-form-item label="订单类型"
                      prop="type">
          <el-select v-model="search.type"
                     placeholder="请选择订单类型"
                     class="width-max"
                     clearable>
            <el-option
              v-for="item in getSortedTaskTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value">
              <template v-if="item.deprecated">
                <span style="float: left;color: #9ba0a5;">{{ item.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.desc }}
                  </span>
              </template>
              <template v-else>
                <span style="float: left;">{{ item.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.desc }}</span>
              </template>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="批次"
                      prop="batchid">
          <remote-select class="width-max"
                         clearable
                         multiple
                         :disabled="!search.projectid"
                         id-key="number"
                         label-key="detail"
                         value-key="id"
                         placeholder="请输入批次 名称/编号 进行搜索"
                         v-model="search.batchid"
                         :query-request="(_) => getBatchTable(Object.assign({projectid: search.projectid}, _))"
                         :find-request="getBatchDetail">
          </remote-select>
        </el-form-item>
        <el-form-item label="订单状态"
                      prop="status">
          <el-select v-model="search.status"
                     multiple
                     placeholder="请选择订单状态"
                     class="width-max"
                     clearable>
            <template v-if="type === 1">
              <el-option
                v-for="item in options.orderstatus"
                :key="item.value"
                :label="item.label"
                :value="String(item.value)">
              </el-option>
            </template>
            <template v-else-if="type === 2">
              <el-option
                v-for="item in options.taskstatus"
                :key="item.value"
                :label="item.label"
                :value="String(item.value)">
              </el-option>
            </template>
            <template v-else-if="type === 3">
              <el-option
                v-for="item in options.status"
                :key="item.value"
                :label="item.label"
                :value="String(item.value)">
              </el-option>
            </template>
          </el-select>
        </el-form-item>

        <el-form-item label="任务模板ID"
                      prop="templateid">
          <el-input placeholder="请输入任务模板id"
                    v-model="search.templateid"></el-input>
        </el-form-item>
        <el-form-item label="完成人ID"
                      v-if="type !== 2"
                      prop="userid">
          <el-input placeholder="请输入完成人id"
                    v-model="search.userid"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="所在区域"
                      prop="taskmarketareaid">
          <el-select v-model="search.taskmarketareaid"
                     placeholder="请选择所在区域"
                     class="width-max"
                     clearable>
            <el-option
              v-for="item in options.taskmarketareaid"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="省市区"
                      prop="query_areas">
          <containment-area-cascader
            v-model="search.query_areas"
            placeholder="请选择省市区">
          </containment-area-cascader>
        </el-form-item>
        <el-form-item label="超市名称"
                      prop="marketname">
          <el-input placeholder="请输入超市名称"
                    v-model="search.marketname"></el-input>
        </el-form-item>
        <el-form-item label="锁定状态"
                      prop="locked"
                      v-if="type !== 2">
          <el-select v-model="search.locked"
                     placeholder="请选择锁定状态"
                     class="width-max"
                     clearable>
            <el-option
              v-for="item in options.locked"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="审核次数"
                      v-if="type !== 2"
                      class="re-el-form__interval">
          <el-row>
            <el-col :span="11">
              <el-form-item prop="review_begin"
                            label-width="0px">
                <el-input placeholder="最小值"
                          v-model="search.review_begin"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <span>~</span>
            </el-col>
            <el-col :span="11">
              <el-form-item prop="review_end"
                            label-width="0px">
                <el-input placeholder="最大值"
                          v-model="search.review_end"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="用户完成时间"
                      v-if="type === 1"
                      prop="userfinishtime"
                      class="re-el-form__interval">
          <el-date-picker v-model="search.userfinishtime"
                          style="width: 100%;"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          align="right"
                          clearable
                          :default-time="['00:00:00', '23:59:59']"
                          value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="初审管理员"
                      v-if="type === 1"
                      prop="first_reviewerid"
                      class="re-el-form__interval">
          <remote-select class="width-max"
                         clearable
                         id-key="id"
                         keyword-key="name"
                         label-key="name"
                         value-key="id"
                         placeholder="请输入管理员名称搜索"
                         v-model="search.first_reviewerid"
                         :query-request="getPlatformUsersIndex"
                         :find-request="getPlatformUsersDetail">
          </remote-select>
        </el-form-item>
        <el-form-item label="目标数标记"
                      v-if="showAddtoTaskgroupTargetNum"
                      prop="addto_taskgroup_target_num">
          <template #label>
            <span>目标数标记<el-tooltip content="自动群组目标数标记任务"><i class="el-icon-warning" /></el-tooltip></span>
          </template>
          <el-select v-model="search.addto_taskgroup_target_num"
                     class="width-max"
                     clearable>
            <el-option
              v-for="item in options.addto_taskgroup_target_num"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="showPlatformSearch" label="签到平台"
                      prop="start_app_type">
          <el-select v-model="search.start_app_type"
                     class="width-max"
                     clearable
                     multiple>
            <el-option
              v-for="item in options.app_type_list"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="showPlatformSearch" label="提交平台"
                      prop="finish_app_type">
          <el-select v-model="search.finish_app_type"
                     class="width-max"
                     clearable
                     multiple>
            <el-option
              v-for="item in options.app_type_list"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="showPlatformSearch"
                      label="工单自主激活"
                      prop="reactive_by_user">
          <el-select v-model="search.reactive_by_user"
                     class="width-max"
                     clearable>
            <el-option label="是" :value="1" />
            <el-option label="否" :value="2" />
          </el-select>
        </el-form-item>
      </div>
      <el-row>
        <div class="re-el-form__flex">
          <el-form-item label="关键字"
                        prop="text">
            <el-input placeholder="请输入关键字"
                      v-model="search.text"
                      style="width: 100%;"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="用户提交位置"
                        prop="finish_query_areas"
                        v-if="type === 1">
            <containment-area-cascader
              v-model="search.finish_query_areas"
              placeholder="请选择用户提交位置">
            </containment-area-cascader>
          </el-form-item>
        </div>
      </el-row>
      <el-form-item>
        <el-button type="primary"
                   icon="el-icon-search"
                   native-type="submit"
                   size="mini">搜索
        </el-button>
        <el-button @click="resetForm('searchForm')"
                   size="mini">重置
        </el-button>
      </el-form-item>

    </el-form>
  </layout-panel>
</template>

<script>
import ContainmentAreaCascader from '@/views/area/components/ContainmentAreaCascader'

export default {
  components: {
    ContainmentAreaCascader,
  },
  props: {
    searchValue: Object,
    showAddtoTaskgroupTargetNum: {
      type: Boolean,
      default: false
    },
    showExcludeProject: {
      type: Boolean,
      default: false
    },
    showPlatformSearch: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 1, // 1工单 2任务 3任务&工单
    },
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.order.options,
    }),
    ...Vuex.mapGetters('order', ['getSortedTaskTypes']),
    search () {
      return this.searchValue
    },
  },
  methods: {
    ...request.map([
      'getProjectTable', 'getProjectDetail', 'getBatchTable', 'getBatchDetail',
    ]),
    ...Vuex.mapActions(['getPlatformUsersIndex', 'getPlatformUsersDetail']),
    onSearch () {
      if (this.search.onlineRange) {
        this.searchValue.start_begin = this.search.onlineRange[0]
        this.searchValue.start_end = this.search.onlineRange[1]
      }
      if (this.search.offlineRange) {
        this.searchValue.endtime_begin = this.search.offlineRange[0]
        this.searchValue.endtime_end = this.search.offlineRange[1]
      }
      if (this.search.lastupdatetimeRange) {
        this.searchValue.lastupdatetime_begin = this.search.lastupdatetimeRange[0]
        this.searchValue.lastupdatetime_end = this.search.lastupdatetimeRange[1]
      }
      if (this.search.userfinishtime) {
        this.searchValue.userfinishtime_begin = this.search.userfinishtime[0]
        this.searchValue.userfinishtime_end = this.search.userfinishtime[1]
      }
      this.$emit('onSearch')
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.search.query_areas = []
      if (this.type === 1) {
        this.search.finish_query_areas = []
      }
    },
    projectIdChanged () {
      if (this.search.batchid.length > 0) {
        this.search.batchid = []
      }
    },
  },
}

</script>



// WEBPACK FOOTER //
// src/views/order/components/OrderSearch.vue